import { render, staticRenderFns } from "./CardsGameOver.vue?vue&type=template&id=279b8102&scoped=true&"
import script from "./CardsGameOver.vue?vue&type=script&lang=js&"
export * from "./CardsGameOver.vue?vue&type=script&lang=js&"
import style0 from "./CardsGameOver.vue?vue&type=style&index=0&id=279b8102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279b8102",
  null
  
)

export default component.exports